<template>
  <b-switch
    :model-value="value"
    :true-value="trueValue"
    :false-value="falseValue"
    :size="size"
    :disabled="disabled"
    @update:model-value="onInput"
  >
    <slot />
  </b-switch>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SwitchView',
  emits: ['input'],
  props: {
    value: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    size: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    onInput(...args) {
      this.$emit('input', ...args);
    }
  }
};
</script>
